/** UpgradeCard — the one card shown wherever content needs premium: what is locked, one button. The button runs the same upgrade flow everywhere. */
import { Clock, Lock } from "lucide-react";
import { Button } from "../ui/Button";
import { useStudent } from "../../context/StudentContext";

type Props = {
  /** One short line: what the student gets by upgrading. */
  message: string;
  title?: string;
  /** Semester the locked content belongs to, so the upgrade page opens on the right plan. */
  semester?: number | null;
};

export function UpgradeCard({ message, title = "Premium", semester }: Props) {
  const { openUpgrade, hasPendingRequest } = useStudent();
  const pending = hasPendingRequest(semester ?? null);
  return (
    <div className="flex flex-col items-start gap-3 rounded-card border border-border bg-card p-5">
      <span className="flex h-11 w-11 items-center justify-center rounded-full bg-accent-soft text-primary" aria-hidden="true">
        {pending ? <Clock size={20} /> : <Lock size={20} />}
      </span>
      <div className="space-y-1">
        <p className="text-base font-semibold">{pending ? "Payment awaiting review" : title}</p>
        <p className="text-sm text-muted-foreground">{pending ? "We will unlock this as soon as your payment is confirmed." : message}</p>
      </div>
      {!pending && <Button onClick={() => openUpgrade(semester ? { semester } : undefined)}>Upgrade to Premium</Button>}
    </div>
  );
}
